import { ReactNode } from 'react'

import HeaderMenu from '~/tutor-on-demand/components/Header/HeaderMenu/HeaderMenu'

export default function HeaderWrapper({ children }: { children: ReactNode }): React.ReactElement {
  const style = {
    background: 'linear-gradient(111.67deg, #7D38D6 25.12%, #58C1FC 110%)',
  }

  return (
    <div className="relative z-20 isolate" style={style}>
      <section className="max-w-4xl xl:max-w-7xl w-full mx-auto">
        <HeaderMenu />
        <section className="relative z-10 p-4 lg:p-8 flex flex-col min-h-39">{children}</section>
      </section>
    </div>
  )
}
